import axios from "axios";
import { BASE_URL } from "./baseUrls";

// Import other dependencies as needed

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

const getTokenFromSessionStorage = () => {
  return sessionStorage.getItem("token");
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getTokenFromSessionStorage();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;

      // Fetch the user role from session storage or wherever it's stored
      const userRole = sessionStorage.getItem("userRole");
      if (userRole) {
        config.headers["X-User-Role"] = userRole;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
